import React, { FC, ReactElement } from 'react';

import classNames from 'classnames';
import { ErrorMessage, useField, useFormikContext } from 'formik';
import { sanitizeElementId } from 'utilities/formUtilities';

interface InputFieldProps {
  id?: string;
  name: string;
  type?: string;
  showError?: boolean;
  label?: string;
  classString?: string;
  shouldValidateForm?: boolean;
}

const RaaInputField: FC<InputFieldProps & React.HTMLProps<HTMLInputElement>> = ({
  id,
  name,
  label,
  classString,
  type = 'text',
  showError = true,
  shouldValidateForm = false,
  ...props
}): ReactElement => {
  const [field, meta] = useField(name);
  const { setFieldTouched, validateField, setFieldValue } = useFormikContext();

  return (
    <>
      {label && (
        <label className="raa-label" htmlFor={id ? id : sanitizeElementId(name)}>
          {label}
        </label>
      )}
      <input
        id={id ? id : sanitizeElementId(name)}
        type={type}
        name={name}
        className={classNames(classString ? classString : 'raa-input', {
          error: meta.touched && meta.error !== undefined
        })}
        value={field.value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setFieldValue(name, event.currentTarget.value, shouldValidateForm)
        }
        onBlur={async () => {
          await setFieldTouched(name, true, shouldValidateForm);

          if (shouldValidateForm) {
            void validateField(name);
          }
        }}
        autoComplete="off"
        aria-invalid={Boolean(meta.error)}
        {...props}
      />
      {showError && <ErrorMessage name={field.name} component="p" className="tw-mt-2 tw-text-raa-error-red" />}
    </>
  );
};

export default RaaInputField;
